import React, { Suspense } from 'react';
import Login from 'pages/login/Login';
import NotFound from 'components/404';
import Loader from 'wrapper/loader';

const BorrowerProfile = React.lazy(() => import('pages/borrower-profile-officer'));
const PipelineAdmin = React.lazy(() => import('pages/pipeline-officer'));
const Dashboard = React.lazy(() => import('pages/dashboard-officer'));
const Tools = React.lazy(() => import('pages/tools-officer'));
const QuickPrice = React.lazy(() => import('pages/quickPrice-officer'));
const Reports = React.lazy(() => import('pages/reports-admin/reports'));
const EmployeeOnboard = React.lazy(() => import('pages/auth/EmployeeOnboard'));
const UserManagement = React.lazy(() => import('pages/user-management-officer'));

const officerRoutes = [
  {
    path: '/',
    element: <Login />,
    children: [
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Dashboard />
          </Suspense>
        ),
        children: [],
      },
      {
        path: ':param/lead',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <BorrowerProfile />
          </Suspense>
        ),
      },
      {
        path: 'pipeline',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <PipelineAdmin />
          </Suspense>
        ),
      },
      {
        path: 'onboard',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <EmployeeOnboard />
          </Suspense>
        ),
      },
      {
        path: 'tools',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Tools />
          </Suspense>
        ),
      },
      {
        path: 'quickPrice',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <QuickPrice />
          </Suspense>
        ),
      },
      {
        path: 'reports',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Reports />
          </Suspense>
        ),
      },
      {
        path: 'user-management',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <UserManagement />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default officerRoutes;
